import {inject, IReactComponent} from 'mobx-react';
import * as view from './view';

const mapStoresToProps = (stores: any) => ({
    ctrl: stores.loginStore.loginController,
    translate: stores.loginStore.localizationService.translate.bind(stores.loginStore.localizationService)
});

const LoginFormView = inject(mapStoresToProps)(view.LoginFormView) as IReactComponent;

export {LoginFormView};
export default LoginFormView;
